import { ReactElement, useCallback, useMemo } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';

import CustomRadioCheckbox from 'features/queue/grid/customRadioCheckbox';
import {
  selectSelectedRowIndex,
  setSelectedRowIndex,
  setPrimarySrId,
} from 'features/queue/grid/actionBar/actions/merge/slice';

const MergeCheckbox = (props: { rowIndex: number }): ReactElement => {
  const dispatch = useDispatch();
  const selectedRowIndex = useSelector(selectSelectedRowIndex);
  const { rowIndex } = props;

  const isSelected = useMemo(() => rowIndex === selectedRowIndex, [rowIndex, selectedRowIndex]);

  const srId = useMemo(() => {
    // @ts-ignore
    const rowNode = props.api.getDisplayedRowAtIndex(rowIndex);
    return rowNode?.data?.[0]?.value;
  }, [rowIndex, props]);

  const handleChange = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRowIndex(isSelected ? null : rowIndex));
      dispatch(setPrimarySrId(isSelected ? null : srId));
    });
  }, [isSelected, rowIndex, dispatch, srId]);

  return <CustomRadioCheckbox value={isSelected} onChange={handleChange} testId={`merge-ticket-checkbox-${srId}`} />;
};

export default MergeCheckbox;
